import {
  assignInventory,
  deleteInvRegistration,
  getBookedSlots,
  getEventRegistrationList,
  getFacility,
  updateAssignInventory,
  viewFacilityReservations,
} from "./action";
export * from './Base_URL';

export const userEndpoint = {
  getAllUsers: "/user/getAllUsers",
  getAllAdmins: "/user/admins",
  createAdmin: "/user/create-admin",
  updateAdminProfile: (id) => `/user/update-admin-profile/${id}`,
  deleteAdmin: (id) => `/user/delete-admin/${id}`,
  // Users search
  searchUsers: (query) => `/user/users/search?query=${query}`,
  deleteUser: (id) => `/user/${id}`,
  approveUser: "/user/updateStatus",
  updateUserStatus: "/user/updateStatus",
  updateUserProfile: (id) => `/user/admin/updateUserProfile/${id}`,
  updateClubStatus: (id) => `/user/admin/updateClubStatus/${id}`,
  // Admin-only create user
  adminCreateUser: `/user/signupbyadmin`,
  deleteAllTempUsers: `/user/delete-all-temp`,
  // Temp user signup (used by admin create user)
  tempUserSignup: `/tempuser/signup`,
  createEvent: "/events/addEvent",
  updateEvent: (id) => `/events/updateEvent/${id}`,
  getEvent: (id) => `/events/getEventById/${id}`,
  createFacility: "/facilities/addFacility",
  updateFacility: (id) => `/facilities/updateFacility/${id}`,
  getFacility: (id) => `/facilities/getFacilityById/${id}`,
  createFacilityReservations: "/facility/registration/addFacilityRegistrations",
  updateFacilityReservations: (id) =>
    `/facility/registration/updateFacilityRegistration/${id}`,
  getFacilityReservation: (id) =>
    `/facility/registration/getFacilityRegistrationById/${id}`,
  getEventRegistrationListbyEventid: (id) =>
    `/event/registration/eventregistrationbyeventid/${id}`,
  deleteEventRegistration: (id) => `/events/deleteEventRegistration/${id}`,
  getEventRegistrationInfo: (event_id, user_id) =>
    `/event/registration/event/${event_id}/user/${user_id}`,
  deleteEventRegistration: (id) =>
    `/event/registration/deleteEventRegistration/${id}`,
  addEventRegistration: `/event/registration/addEventRegistration`,
  updateEventRegistration: (id) =>
    `/event/registration/updateEventRegistration/${id}`,
  getFacilityRegistrationInfo: (facility_id, user_id) =>
    `/facility/registration/facility/${facility_id}/user/${user_id}`,
  deleteFacilityRegistration: (id) =>
    `/facility/registration/deleteFacilityRegistration/${id}`,
  addFacilityRegistration: `/facility/registration/addFacilityRegistrations`,
  updateFacilityRegistration: (id) =>
    `/facility/registration/updateFacilityRegistration/${id}`,
  getBookedSlots: (facility_id) =>
    `/facility/registration/timmings/${facility_id}`,
  assignInventory: `/api/inventory/registration/createInventoryRegistration`,
  updateAssignInventory: (id) =>
    `/api/inventory/registration/updateInventoryRegistration/${id}`,
  getInvRegistrationInfo: (inv_id, user_id) =>
    `/api/inventory/registration/userid/${user_id}/inventory/${inv_id}`,
  deleteInvRegistration: (id) =>
    `/api/inventory/registration/deleteInventoryRegistration/${id}`,
  // Clubs
  addClub: `/clubs/addClub`,
  getAllClubs: `/clubs/getAllClubs`,
  getClubById: (id) => `/clubs/getClubById/${id}`,
  updateClub: (id) => `/clubs/updateClub/${id}`,
  deleteClub: (id) => `/clubs/deleteClub/${id}`,
  // Clubs search
  searchClubs: (name) => `/clubs/search?name=${name}`,
  // Labs
  addLab: `/labs/addLab`,
  getAllLabs: `/labs/getAllLabs`,
  getLabById: (id) => `/labs/getLabById/${id}`,
  updateLab: (id) => `/labs/updateLab/${id}`,
  deleteLab: (id) => `/labs/deleteLab/${id}`,
  // Lab Incharge
  addLabIncharge: `/labincharge/addLabIncharge`,
  getAllLabIncharges: `/labincharge/getAllLabIncharges`,
  getLabInchargeById: (id) => `/labincharge/getLabInchargeById/${id}`,
  updateLabIncharge: (id) => `/labincharge/updateLabIncharge/${id}`,
  deleteLabIncharge: (id) => `/labincharge/deleteLabIncharge/${id}`,
  updateLabInchargePassword: (id) => `/labincharge/updatePasswordDirect/${id}`,
  // Inventory Registration Status
  updateInventoryRegistrationStatus: (id) =>
    `/api/inventory/registration/${id}/status`,
  // Blogs
  getAllBlogs: "/api/blogs",
  getBlogBySlug: (slug) => `/api/blogs/${slug}`,
  // Links
  getAllLinks: "/api/links",
  updateLink: (id) => `/api/links/${id}`,

  // Projects
  getAllProjects: "/api/projects",
  getProjectById: (id) => `/api/projects/${id}`,
  getStudentProjects: (id) => `/api/projects/student/${id}`,
  createProject: "/api/projects",
  updateProject: (id) => `/api/projects/${id}`,
  deleteProject: (id) => `/api/projects/${id}`,
  updateProjectStatus: (id) => `/api/projects/${id}/status`,
  addProjectEvaluation: (id) => `/api/projects/${id}/evaluations`,
  deleteProjectEvaluation: (id, evalId) => `/api/projects/${id}/evaluations/${evalId}`,
  updateProjectEvaluation: (id, evalId) => `/api/projects/${id}/evaluations/${evalId}`,
  // Members
  getAllMembers: "/api/members",
  getMemberById: (id) => `/api/members/${id}`,
  createMember: "/api/members",
  updateMember: (id) => `/api/members/${id}`,
  deleteMember: (id) => `/api/members/${id}`,
  // Head Desk
  getHeadDesk: "/headdesk",
  updateHeadDesk: "/headdesk",
};
